import { paths } from 'config'
import { LockDevices } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: `${paths.lockDevices}`,
    isSuperAdmin: true,
    exact: true,
    linkSettings: {
      icon: LockDevices,
      label: 'nav.lockDevices',
      to: paths.lockDevices,
    },
    component: Loadable({
      component: () => import('./pages/LockDevices'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.lockDevice,
    isSuperAdmin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/LockDevice'),
    }),
    layoutSettings: {
      contentProps: {
        lockViewportHeight: true,
        style: { overflowY: 'hidden' },
      },
    },
  },
]

export default routes
